import {
  showErrorMessage,
  showSuccessMessage,
} from '../../../components/ToastComponent/store/toastMiddleware';
import { type AppDispatch } from '../../../redux/store';
import { createBranchTransfer, createInvestment, getBranchTransfers, getInvestment, updateInvestment, getSuspenseTransactions, deleteSuspense } from './investmentMiddleware';
import { type BranchTransfer, type Investment, type UpdateInvestmentRequest } from './investmentTypes';

export const createInvestmentAction = async (
  dispatch: AppDispatch,
  payload: Investment
) => {
  const data = {
    ...payload,
  };
  const res = await dispatch(createInvestment(data));

  if (res.meta.requestStatus === 'fulfilled') {
    dispatch(showSuccessMessage('Investment added Successfully'));
  } else {
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    dispatch(showErrorMessage(res.payload?.response?.data?.message || 'Error adding investment'));
    return false;
  }
};

export const updateInvestmentAction = async (
  dispatch: AppDispatch,
  payload: UpdateInvestmentRequest
) => {
  const data = {
    ...payload,
  };
  const res = await dispatch(updateInvestment(data));

  if (res.meta.requestStatus === 'fulfilled') {
    dispatch(showSuccessMessage('Investment updated Successfully'));
  } else {
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    dispatch(showErrorMessage(res.payload?.response?.data?.message || 'Error updating investment'));
    return false;
  }
};

export const getInvestmentAction = async (
  dispatch: AppDispatch,
  payload: any
) => {
  const res = await dispatch(getInvestment(payload));
  console.log(res);
};

export const createBranchTransferAction = async (
  dispatch: AppDispatch,
  payload: BranchTransfer
) => {
  const data = {
    ...payload,
  };
  const res = await dispatch(createBranchTransfer(data));

  if (res.meta.requestStatus === 'fulfilled') {
    dispatch(showSuccessMessage('Branch transfer added Successfully'));
  } else {
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    dispatch(showErrorMessage(res.payload?.response?.data?.message || 'Error adding branch transfer'));
    return false;
  }
};

export const getBranchTransferAction = async (
  dispatch: AppDispatch,
  payload: any
) => {
  const res = await dispatch(getBranchTransfers(payload));
  console.log(res);
};

export const getSuspenseTransactionsAction = async (
  dispatch: AppDispatch,
  payload: any
) => {
  const res = await dispatch(getSuspenseTransactions(payload));
  console.log(res);
};

export const deleteSuspenseAction = async (
  dispatch: AppDispatch,
  payload: {id: string}
) => {
  const data = {
    ...payload,
  };
  const res: any = await dispatch(deleteSuspense(data));

  
  if (res.meta.requestStatus === 'fulfilled') {
    dispatch(showSuccessMessage('Suspense deleted Successfully'));
  } else {
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    dispatch(showErrorMessage(res.payload?.response?.data?.message || 'Error deleting suspense'));
    return false;
  }
};
